<div class="agpr-madSummary">
    <div
        id="madSummaryTrend"
        class="agpr-madSummary-summaryTrend agpr-contextMenu-parent"
        #madSummaryTrendElement
    >
        <div class="agpr-madSummary-exportMenu agpr-contextMenu top right">
            <agpr-chart-export-menu
                id="madSummaryTrend_export"
                iconStyleClass="fa-regular fa-arrow-right-from-bracket"
                [supportedFormats]="[ 'png', 'jpg', 'svg', 'print' ]"
                (exportMenuClicked)="summaryTrendExport($event, madSummaryTrendElement, madSummaryChartTypeEnum.COVERAGE_OVER_TIME)"
                [contextMenu]="true"
                [social]="true"
            ></agpr-chart-export-menu>
        </div>
        <label class="agpr-madSummary-summaryTrend-header">{{ 'Monitor.MAD.summary.summaryTrend' | localize }}</label>
        <div class="agpr-madSummary-summaryTrend-charts">
            <div class="agpr-madSummary-summaryTrend-left">
                <agpr-card-chart
                    class="agpr-madSummary-card--column"
                    [series]="totalVolumeCardSeries"
                    [color]="cardChartComponentHighlightColors.volume"
                    [layout]="cardChartLayoutTypes.vertical"
                    bubbleTooltipSubjectLocalizationString="Monitor.MAD.summary.bubbleTooltipSubject"
                    [bubbleTooltipMetric]="MADSummarySeriesTypes.totalVolumeCard"
                    [headingLevel]="4"
                ></agpr-card-chart>
                <agpr-card-chart
                    class="agpr-madSummary-card--column"
                    [series]="totalImpressionCardSeries"
                    [color]="cardChartComponentHighlightColors.impressions"
                    [layout]="cardChartLayoutTypes.vertical"
                    [bubbleTooltipMetric]="socialMetrics.IMPRESSIONS"
                    [headingLevel]="4"
                ></agpr-card-chart>
                <agpr-card-chart
                    class="agpr-madSummary-card--column"
                    [series]="totalAVECardSeries"
                    [color]="cardChartComponentHighlightColors.ave"
                    [layout]="cardChartLayoutTypes.vertical"
                    [bubbleTooltipMetric]="socialMetrics.AVE"
                    [headingLevel]="4"
                    [showCurrency]="true"
                ></agpr-card-chart>
            </div>
            <div class="agpr-madSummary-summaryTrend-right">
                <div
                    class="agpr-mad-chartAnchor {{ summaryTrendLineChartClass }}"
                    [agprLoading]="loading"
                >
                    <agpr-am5-chart
                        [ngClass]="{ 'agpr-madSummary-chart--noData': summaryTrendLineChartNoData }"
                        [chart]="summaryTrendLineChart"
                        [series]="summaryTrendLineSeries"
                        (noContent)="updateSummaryTrendLineChartNoData($event)"
                        (tooltipLinkClick)="openAm5ChartDrilldown($event)"
                    ></agpr-am5-chart>
                </div>
            </div>
        </div>
    </div>

    <div class="agpr-madSummary-cards">
        <div class="agpr-madSummary-cards-card">
            <agpr-card-chart
                [series]="positiveCardSeries"
                [color]="cardChartComponentHighlightColors.positive"
                [bubbleTooltipMetric]="socialMetrics.POSITIVE"
                [headingLevel]="4"
            ></agpr-card-chart>
        </div>
        <div class="agpr-madSummary-cards-card">
            <agpr-card-chart
                [series]="negativeCardSeries"
                [color]="cardChartComponentHighlightColors.negative"
                [bubbleTooltipMetric]="socialMetrics.NEGATIVE"
                [headingLevel]="4"
            ></agpr-card-chart>
        </div>
        <div class="agpr-madSummary-cards-card">
            <agpr-card-chart
                class="agpr-madSummary-cards-averageDomainAuthority"
                [series]="averageDomainAuthorityCardSeries"
                [color]="cardChartComponentHighlightColors.averageDomainAuthority"
                tooltipIconInfo="Monitor.MAD.summary.averageDomainAuthority.tooltip"
                bubbleTooltipSubjectLocalizationString="Monitor.MAD.summary.bubbleTooltipSubject"
                [bubbleTooltipMetric]="MADSummarySeriesTypes.averageDomainAuthority"
                [headingLevel]="4"
            >
                <div class="agpr-madSummary-cards-averageDomainAuthority-iconLink">
                    <a
                        target="_blank"
                        href="https://moz.com"
                    >
                        <img
                            class="agpr-madSummary-cards-averageDomainAuthority-iconLink-mozLogo"
                            [src]="appBaseHref + 'assets/images/moz-logo.svg'"
                            [alt]="'Common.domainAuthority.moz' | localize"
                        />
                    </a>
                </div>
            </agpr-card-chart>
        </div>
    </div>

    <!-- COVERAGE BY MEDIA TYPE -->
    <div
        class="agpr-madSummary-mediaTypeBreakdown agpr-contextMenu-parent"
        #madSummarymediaTypeBreakdownElement>
        <div class="agpr-madSummary-exportMenu agpr-contextMenu top right">
            <agpr-chart-export-menu
                id="madSummarymediaTypeBreakdown_export"
                iconStyleClass="fa-regular fa-arrow-right-from-bracket"
                [supportedFormats]="[ 'png', 'jpg', 'svg', 'print' ]"
                (exportMenuClicked)="exportChart($event, madSummarymediaTypeBreakdownElement, madSummaryChartTypeEnum.MEDIA_TYPE_BREAKDOWN)"
                [contextMenu]="true"
                [social]="true"
            ></agpr-chart-export-menu>
        </div>
        <h4 class="agpr-madSummary-metric">
            {{ 'Monitor.MAD.summary.mediaTypeBreakdown.title' | localize }} -
            <agpr-dropdown
                *ngIf="mediaTypeBreakdownSeries"
                [id]="id + '_mediaTypeBreakdownMetricDropdown'"
                class="agpr-madSummary-metric-dropdown"
                [style]="dropdownTypes.borderless"
                [agprStyle]="agprComponentStyle.social"
                [options]="mediaTypeBreakdownDropdownOptions"
                ariaLabel="Social.intelligence.charts.wordCloud.dropdownLabel"
                [(ngModel)]="selectedMediaTypeBreakdownChartDropdownOption"
                (ngModelChange)="mediaTypeBreakdownDropdownOptionChange($event.value)"
                panelStyleClass="agpr-dropdown-panelSocial"
            ></agpr-dropdown>
        </h4>
        <div class="agpr-mad-chartAnchor {{ mediaTypeBreakdownChartClass }}">
            @if (mediaTypeBreakdownChartNoData) {
                <agpr-message
                    class="agpr-madSummary-chart-noContentMessage"
                    [severity]="messageSeverities.noContent"
                >
                    {{ 'Monitor.MAD.chart.noContentLabel' | localize }}
                </agpr-message>
            }
            <agpr-reports-chart
                [ngClass]="{ 'agpr-madSummary-chart--noData': mediaTypeBreakdownChartNoData }"
                [chart]="mediaTypeBreakdownChart"
                (noContent)="updateMediaTypeBreakdownChartNoData($event)"
            ></agpr-reports-chart>
        </div>
    </div>

    <div
        class="agpr-madSummary-map agpr-contextMenu-parent"
        #madSummaryMapElement>
        <div class="agpr-mad-chartAnchor {{ mapChartClass }}">
            <div class="agpr-madSummary-exportMenu agpr-contextMenu top right">
                <agpr-chart-export-menu
                    id="madSummaryMap_export"
                    iconStyleClass="fa-regular fa-arrow-right-from-bracket"
                    [supportedFormats]="[ 'png', 'jpg', 'svg', 'print' ]"
                    (exportMenuClicked)="exportChart($event, madSummaryMapElement, madSummaryChartTypeEnum.GEOGRAPHY_BREAKDOWN_BY_VOLUME)"
                    [contextMenu]="true"
                    [social]="true"
                ></agpr-chart-export-menu>
            </div>
            <h4 class="agpr-madSummary-mapChart-title">
                <span class="agpr-madSummary-mapChart-titleText">{{ 'Monitor.MAD.summary.mapChart.title' | localize }} -</span>
                <agpr-dropdown
                    class="agpr-madSummary-metric-dropdown"
                    [style]="dropdownTypes.borderless"
                    [agprStyle]="agprComponentStyles.social"
                    panelStyleClass="agpr-dropdown-panelSocial"
                    [options]="mapChartDropdownOptions"
                    [(ngModel)]="selectedMapChartDropdownOption"
                    (ngModelChange)="mapChartDropdownOptionChanged($event)"
                ></agpr-dropdown>
            </h4>
            <agpr-reports-chart
                [ngClass]="{ 'agpr-madSummary-chart--noData': mapChartNoData }"
                [chart]="mapChart"
                (noContent)="updateMapChartNoData($event)"
            ></agpr-reports-chart>
            @if (mapChartNoData) {
                <agpr-message
                    class="agpr-madSummary-chart-noContentMessage"
                    [severity]="messageSeverities.noContent"
                >
                    {{ 'Monitor.MAD.chart.noContentLabel' | localize }}
                </agpr-message>
            }
        </div>
    </div>
    <!-- Top Outlets and Top Authors -->
    <div class="agpr-mad-chartAnchor">
        <agpr-top-entities-chart-block
            [block]="topOutletsBlock"
            [series]="topOutletsSeries"
            [entityType]="entityType.OUTLET"
            [metricSelectable]="true"
            [bigProfileImage]="true"
            [height]="585"
            [canViewProfileDetail]="true"
            [shouldValidateSeries]="false"
            (seriesChange)="topEntitiesChartSeriesUpdate($event)"
        ></agpr-top-entities-chart-block>
    </div>
    <div class="agpr-mad-chartAnchor">
        <agpr-top-entities-chart-block
            [block]="topAuthorsBlock"
            [series]="topAuthorsSeries"
            [entityType]="entityType.CONTACT"
            [metricSelectable]="true"
            [bigProfileImage]="true"
            [height]="585"
            [canViewProfileDetail]="true"
            [shouldValidateSeries]="false"
            (seriesChange)="topEntitiesChartSeriesUpdate($event)"
        ></agpr-top-entities-chart-block>
    </div>
    <!-- Top Mentions -->
    <div id="madSummaryTopMentions" class="agpr-madSummary-summaryTopMentions agpr-mad-chartAnchor agpr-second-contextMenu-parent" #madSummaryTopMentionsElement>
        <div class="agpr-second-contextMenu top right">
            <agpr-chart-export-menu id="madSummarytopMentions_export"
                iconStyleClass="fa-regular fa-arrow-right-from-bracket"
                [supportedFormats]="[ 'png', 'jpg', 'svg', 'print' ]"
                (exportMenuClicked)="topMentionsExport($event, madSummaryTopMentionsElement, madSummaryChartTypeEnum.TOP_MENTIONS)"
                [contextMenu]="true" [social]="true"></agpr-chart-export-menu>
        </div>

        @if (topMentionsSeries) {
        <agpr-top-mentions-mad-chart [series]="topMentionsSeries" (seriesChange)="topMentionsSeriesChange($event)"
            (openDrilldown)="openTopMentionsDrilldown()"></agpr-top-mentions-mad-chart>
        }
    </div>
</div>
